import React from "react";

import { TextState, Preview } from "@creatomate/preview";
import { SelectOption } from "@culturehq/components/dist/components/form/typings";

import { Trans } from "app/utils";
import { BuiltInFontDefinition } from "components/stories/video-studio/fonts/BuiltInFonts";
import TextProperty from "../TextProperty";

interface FontStyleProps {
  activeElement: TextState;
  disabled?: boolean;
  onSubtitleChange?: (propertyName: string, value: string) => Promise<void>;
  preview: Preview;
  selectedFont?: BuiltInFontDefinition;
  styles: SelectOption[];
}

const FontStyle: React.FC<FontStyleProps> = ({
  activeElement,
  disabled,
  onSubtitleChange,
  preview,
  selectedFont,
  styles
}) => (
  <div className="chq-ffd2">
    <TextProperty
      activeElement={activeElement}
      defaultValue={selectedFont?.styles?.find(font => font === "normal") ? "normal" : selectedFont?.styles[0] || ""}
      disabled={disabled}
      name="font-style"
      onSubtitleChange={onSubtitleChange}
      options={styles}
      preview={preview}
      propertyName="font_style"
    >
      <Trans>Style</Trans>
    </TextProperty>
  </div>
);

export default FontStyle;
